import { IconWrapper } from '../runtime';
export default IconWrapper('align-vertical', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M1.75 7.99976H14.25M8 14.2498V10.2498M8 10.2498L5.5 12.7498M8 10.2498L10.5 12.7498M8 1.74976V5.74976M8 5.74976L5.5 3.24976M8 5.74976L10.5 3.24976",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});